import { documentsApiRef } from '@agilelab/plugin-wb-builder-catalog';
import { WitboostDocumentWithAcceptanceDate } from '@agilelab/plugin-wb-documents-common';
import {
  TableCellProps,
  customAlertApiRef,
  useTruncatedStyles,
} from '@agilelab/plugin-wb-platform';
import { useApi } from '@mainstage/core-plugin-api';
import { Button } from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

export function useDocumentsTabColumns(): TableCellProps<WitboostDocumentWithAcceptanceDate>[] {
  const documentsApi = useApi(documentsApiRef);
  const alertApi = useApi(customAlertApiRef);
  const truncatedClass = useTruncatedStyles({});

  const fetchDocument = async (document_id: number) => {
    try {
      const documentFile = await documentsApi.retrieveSingleDocumentBlob(
        document_id,
      );

      const fileURL = URL.createObjectURL(documentFile);

      const pdfWindow = window.open();
      if (!pdfWindow) {
        alertApi.post({
          message: 'Unable to open new window.',
        });
      }
      pdfWindow!.location.href = fileURL;
    } catch (error) {
      alertApi.post({
        error: error,
        severity: 'error',
      });
    }
  };

  return [
    {
      field: 'name',
      headerName: 'Name',
      width: '10%',
      sortable: true,
    },
    {
      field: 'description',
      headerName: 'Description',
      tooltip: true,
      width: '20%',
      typographyProps: {
        component: 'p',
        className: truncatedClass.truncated,
      },
      sortable: true,
    },
    {
      field: 'document_type',
      headerName: 'Document type',
      width: '10%',
      sortable: true,
    },
    {
      field: 'acceptance_date',
      headerName: 'Acknowledgment date',
      width: '10%',
      fieldRender: document =>
        document.acceptance_date
          ? format(new Date(document.acceptance_date), 'dd/MM/yyyy, HH:mm:ss', {
              locale: it,
            })
          : null,
      sortable: true,
    },
    {
      field: 'id',
      headerName: 'View',
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      resizable: false,
      fieldRender: document => (
        <>
          <Button
            onClick={() => {
              fetchDocument(document.id!);
            }}
          >
            <LaunchIcon />
          </Button>
        </>
      ),
    },
  ];
}
